export const handleError = (error) => {
    console.error('Hata:', error);
    return error.message || 'Bir hata oluştu.';
};

export const handleApiError = (error, callback) => {
    const message = handleError(error);
    if (callback) callback(message);
}; 